var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React from 'react';
import { withRouter } from "../componentWrappers";
import { requestState } from "./helpers/requestState";
import { MapView } from "./components/MapView";
import LibraryLayout from "./LibraryLayout";
import Library from "./Library";
import LibraryModeToggleButtons from "./components/LibraryModeToggleButtons";
import { trackPage } from "../App/GoogleAnalytics";

class LibraryMapComponent extends Library {
  static async requestState(requestParams, globalResources) {
    return requestState(requestParams, globalResources, { geolocation: true });
  }

  render() {
    trackPage();
    return /*#__PURE__*/(
      _jsx(LibraryLayout, { className: "library-map-layout" }, void 0, /*#__PURE__*/
      _jsx(LibraryModeToggleButtons, { mapViewMode: true }), /*#__PURE__*/
      React.createElement(MapView, {
        storeKey: "library",
        ref: (ref) => {
          this.mapView = ref;
        } }
      )
      ));

  }
}
const SSRLibraryComponent = withRouter(LibraryMapComponent);

const LibraryMap = Object.assign(SSRLibraryComponent, {
  requestState: LibraryMapComponent.requestState
});

export { LibraryMapComponent };
export { LibraryMap };